module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/babel-runtime/core-js/object/define-property.js
// module id = 625
// module chunks = 114276838955818